import { render, staticRenderFns } from "./servicios-higiene-ver.vue?vue&type=template&id=ab32de74&scoped=true&"
import script from "./servicios-higiene-ver.vue?vue&type=script&lang=js&"
export * from "./servicios-higiene-ver.vue?vue&type=script&lang=js&"
import style0 from "./servicios-higiene-ver.vue?vue&type=style&index=0&id=ab32de74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab32de74",
  null
  
)

export default component.exports